<template>
    <div>
        <a-spin :spinning="spinning">
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    :colon="false"
            >
                <a-form-model-item ref="site_url" label="网站网址" prop="site_url" :help="formErr.site_url"
                                   :validateStatus='!formErr.site_url||formErr.site_url ==""?"":"error"'>
                    <a-input v-model="form.site_url" @change="(e) => { formErr.site_url='';changetab=2}"
                             :maxLength="200"
                             @blur="(e) => {  form.site_url = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="site_name" label="网站名称" prop="site_name" :help="formErr.site_name"
                                   :validateStatus='!formErr.site_name||formErr.site_name==""?"":"error"'>
                    <a-input v-model="form.site_name" @change="(e) => { formErr.site_name='';changetab=2}"
                             :maxLength="20"
                             @blur="(e) => {  form.site_name = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item label="LOGO" :help="formErr.logo_thumb"
                                   :validateStatus='!formErr.logo_thumb||formErr.logo_thumb==""?"":"error"'>
                    <a-upload
                            :action="this.$store.state.urlChang"
                            :data="{type:1}"
                            :file-list="fileList"
                            :headers="headers"
                            @change="(file)=>{handleChange(file)}"
                            :before-upload="beforeUpload"
                            @preview="handlePreview"
                            list-type="picture-card"
                            name="file"
                    >
<!--                        @change="handleChange"-->
<!--                        @preview="handlePreview"-->
<!--                        :before-upload="beforeUpload"-->
                        <div v-if="fileList.length < 1">
                            <a-icon type="plus"/>
                            <div class="ant-upload-text">Upload</div>
                        </div>
                    </a-upload>
                    <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                        <img :src="previewImage" alt="example" style="width: 100%"/>
                    </a-modal>

                </a-form-model-item>

                <a-form-model-item ref="site_icp" label="ICP备" prop="site_icp" :help="formErr.site_icp"
                                   :validateStatus='!formErr.site_icp||formErr.site_icp==""?"":"error"'>
                    <a-input v-model="form.site_icp" @change="(e) => { formErr.site_icp='';changetab=2}"
                             @blur="(e) => {  form.site_icp = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="site_gwa" label="公安备案" prop="site_gwa" :help="formErr.site_gwa"
                                   :validateStatus='!formErr.site_gwa||formErr.site_gwa==""?"":"error"'>
                    <a-input v-model="form.site_gwa" @change="(e) => { formErr.site_gwa='' ;changetab=2}"
                             @blur="(e) => {  form.site_gwa = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="site_admin_email" label="站长邮箱" prop="site_admin_email"
                                   :help="formErr.site_admin_email"
                                   :validateStatus='!formErr.site_admin_email||formErr.site_admin_email==""?"":"error"'>
                    <a-input v-model="form.site_admin_email"
                             @change="(e) => { formErr.site_admin_email='' ;changetab=2}"
                             @blur="(e) => {  form.site_admin_email = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="site_analytics_head" label="统计代码" prop="site_analytics_head"
                                   :help="formErr.site_analytics_head"
                                   :validateStatus='!formErr.site_analytics_head||formErr.site_analytics_head==""?"":"error"'>
                    <span>{{head}}</span>
                    <a-textarea :maxLength=200 :rows="4" v-model="form.site_analytics_head"
                                @change="(e) => { formErr.site_analytics_head='';changetab=2}"
                                @blur="(e) => {  form.site_analytics_head = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item ref="site_analytics_body" label=" " prop="site_analytics_body"
                                   :help="formErr.site_analytics_body"
                                   :validateStatus='!formErr.site_analytics_body||formErr.site_analytics_body==""?"":"error"'>
                    <span>{{body}}</span>
                    <a-textarea :maxLength=200 :rows="4" v-model="form.site_analytics_body"
                                @change="(e) => { formErr.site_analytics_body='';changetab=2}"
                                @blur="(e) => {  form.site_analytics_body = e.target.value.trim() }"/>
                </a-form-model-item>
                <a-form-model-item label=" ">
                    <a-button type="primary" @click="onSubmit">
                        确认
                    </a-button>
                    <!--                    <a-button style="margin-left: 10px;" @click="resetForm">-->
                    <!--                        -->
                    <!--                    </a-button>-->
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </div>

</template>

<script>
    import {submitForm, validator} from '../../../../utils/utils';
    import API from "../api"

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "webForm",
        props: ["changeTabs"],
        data() {
            return {
                changetab: 1,
                body: "<body></body>之间",
                head: "<head></head>之间",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                loading: false,
                previewVisible: false,
                previewImage: "",
                fileList: [],
                spinning: true,
                formErr: {
                    site_url: "",
                    site_name: "",
                    logo_thumb: "",
                    site_icp: "",
                    site_gwa: "",
                    site_admin_email: "",
                    site_analytics_head: "",
                    site_analytics_body: "",
                },
                labelCol: {span: 4},
                wrapperCol: {span: 10},
                other: '',
                form: {
                    site_url: "",
                    site_name: "",
                    logo_thumb: "",
                    site_icp: "",
                    site_gwa: "",
                    site_admin_email: "",
                    site_analytics_head: "",
                    site_analytics_body: "",
                },
                rules: {
                    site_url: [{required: true, message: '请填写网站网址'}, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.site_url)
                        }, trigger: "blur"
                    },],
                    site_name: [{required: true, message: '请填写网站名称'}, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.site_name)
                        }, trigger: "blur"
                    },],
                },
            };
        },
        watch: {
            changeTabs: function (a, b) {
                let _this = this
                if (a == 1) {
                }
            }
        },
        mounted() {
            this.getFormData()
        },
        methods: {
            checkVal() {
                this.onSubmit()
                this.changetab = 1
            },
            getFormData() {
                API.WebsiteInformation.GET_WEBSITE().then(res => {
                    this.form = res.data.data
                    if (this.form.site_logo == "") {
                        this.fileList = []
                    } else {
                        this.fileList = [
                            {
                                uid: this.form.site_logo,
                                name: this.form.site_logo,
                                status: "done",
                                url: this.form.site_logo ? this.form.site_logo : ""
                            }
                        ]
                    }

                    this.spinning = false;
                })
                this.changetab = 1
            },
            handleCancel() {
                this.previewVisible = false;
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            handleChange(info) {
                // this.fileList = fileList;
                this.changetab = 2
                this.formErr.site_logo = "";
                // if (this.fileList.length < 1) {
                //     // this.formErr.logo_thumb = "LOGO不能为空"
                // }
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    this.fileList=[]
                }
                if (status === 'done') {
                    this.formErr.site_logo=""
                    this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.formErr.site_logo=""
                        this.fileList= fileList
                    });
                }
            },
            beforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('只能上传jpeg、jpg，png类型图片!');
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('图片必须小于 2MB!');
                    return false
                }
                return new Promise(function (resolve,reject) {
                    resolve(file)
                })
            },
            onSubmit() {
                let _this = this;
                // if (this.fileList.length < 1) {
                //     // _this.formErr.logo_thumb = "LOGO不能为空";
                //     //
                //     // return
                // } else {
                //     this.form.site_logo = this.fileList[0].url
                // }
                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.site_logo = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.site_logo = this.fileList[0].response.data.url
                } else {
                    this.form.site_logo = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        submitForm(API.WebsiteInformation.SET_SITEINFO, {type: 1, ...this.form}).then(res => {
                            if (res == true) {
                                this.getFormData()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                        this.getFormData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm() {
                this.$refs.ruleForm.resetFields();
            },
        },
    }
</script>

<style scoped>

</style>
